import { useState } from 'react'

function useToast() {
  const [toastList, setToastList] = useState([])

  function addToastMessage(message, type, action = null) {
    const id = crypto.randomUUID()

    if (toastList.length > 2) {
      toastList.splice(0, 1)
    }

    setToastList([...toastList, { id, type, message, action }])
  }

  return { toastList, setToastList, addToastMessage }
}

export default useToast
